import {
    DataSource,
    Layout,
    Label,
    Panel,
    Switch
} from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlQuickInfo extends Layout {
    sourceMCControl: DataSource;
    panelMobileCommControlQuickInfo: Panel;
    labelVendorId: Label;
    labelVendorName: Label;
    labelActive: Label;
    labelAccountName: Label;
    labelContactName: Label;
    labelContactPhone: Label;
    panelServices: Panel;
    labelServicesHeader: Label;
    switchMobileDispatchQI: Switch;
    switchCommunicationsQI: Switch;
    switchTrailerTrackingQI: Switch;
    switchReeferTrackingQI: Switch;
}
